import { render, staticRenderFns } from "./SendMessageToAdmin.vue?vue&type=template&id=3f9ee5c0&"
import script from "./SendMessageToAdmin.vue?vue&type=script&lang=js&"
export * from "./SendMessageToAdmin.vue?vue&type=script&lang=js&"
import style0 from "./SendMessageToAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports